import styled from 'styled-components'

export const MyDriveContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
	height: 100%;
`

export const MyDriveDetailContent = styled.div`
	display: flex;
	flex-direction: column;
  gap: 16px;
  max-height: calc(100vh - 380px);
  overflow-y: auto;
  padding-right: 8px;
	
	& > div {
		width: 100%;
	}

  &::-webkit-scrollbar {
      width: 6px;
  }

  &::-webkit-scrollbar-track {
      background: ${props => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.colors.lighterGray};
      border-radius: 3px;
  }
`

export const GoToDriveButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-top: 20px;
`